import { icons } from 'lucide';
/** Subpath not in package typings; mirrors lucide `createIcons` replacement, scoped to `root`. */
import replaceElement from 'lucide/dist/esm/replaceElement.js';

/**
 * Replace `span.indmo-richtext-icon[data-indmo-icon]` placeholders (from Wagtail rich text)
 * with Lucide SVGs, only under `root` (avoids `createIcons` scanning the whole document).
 */
export function hydrateIndmoRichTextIcons(root: HTMLElement | null | undefined): void {
  if (!root) return;

  root.querySelectorAll<HTMLSpanElement>('span.indmo-richtext-icon[data-indmo-icon]').forEach((span) => {
    const name = span.getAttribute('data-indmo-icon');
    if (!name) return;
    span.replaceChildren();
    const i = document.createElement('i');
    i.setAttribute('data-lucide', name);
    i.setAttribute('aria-hidden', 'true');
    span.appendChild(i);
  });

  const attrs = { 'stroke-width': '2' };
  root.querySelectorAll<HTMLElement>('.indmo-richtext-icon [data-lucide]').forEach((el) => {
    replaceElement(el, { nameAttr: 'data-lucide', icons, attrs });
  });
}
